module.exports = __webpack_public_path__ + "img/close_x_blue.697b9375.svg";